import { DatePipe } from '@angular/common';
import { Component, OnInit, inject, ChangeDetectionStrategy, signal, input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import {EntityService} from '../services/entity-service';
import {IecTaskService} from '../services/iec-task-service';
import {PersonLoginService} from '../services/person-login-service';
import {TaskResponseService} from '../services/task-response-service';
import {DateUtils} from '../utils/date-utils';
import {StringUtils} from '../utils/string-utils';
import {IecTask} from './iec-task';
import {TaskResponse} from './task-response';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from '@angular/material/datepicker';

@Component({
    selector: 'parts-ship-date-task',
    templateUrl: './parts-ship-date-task.component.html',
    styleUrls: ['./parts-ship-date-task.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatDatepickerInput, MatDatepickerToggle, MatDatepicker, MatButton, MatIcon, MatProgressSpinner]
})
export class PartsShipDateTaskComponent implements OnChanges, OnInit {
  private readonly personLoginService = inject(PersonLoginService);
  private readonly entityService = inject(EntityService);
  private readonly taskResponseService = inject(TaskResponseService);
  private readonly iecTaskService = inject(IecTaskService);
  private readonly router = inject(Router);
  private readonly datePipe = inject(DatePipe);
  readonly taskId = input.required<string>({ alias: 'task-id' });


  private shipDate: Date = new Date();
  readonly task = signal<IecTask>(undefined!);
  response!: TaskResponse;
  readonly isBusy = signal<boolean>(false);
  readonly errorMessage = signal<string>(undefined!);
  readonly expediteParts = signal<boolean>(undefined!);
  readonly partialShipments = signal<boolean>(undefined!);

  ngOnInit(): void {
    if (this.personLoginService.isOutsideEngineer()) {
      this.router.navigate(['ratings']);
    } else {
      this.response = new TaskResponse();
      this.personLoginService.getCachedLogin();
      this.initialize();
    }
  }

  formatShipDate(): Date {
    return DateUtils.formatDisplay(this.shipDate);
  }

  setShipDate(newValue: Date) {
    this.shipDate = DateUtils.formatOutput(newValue);
  }

  goToQuote(): void {
    this.router.navigate(['quotes', this.task().entityId, this.task().entityRevision]);
  }

  saveResponse(): void {
    this.isBusy.set(true);
    this.response.additionalData = this.datePipe.transform(this.formatShipDate(), 'MM/dd/yyyy')!;
    this.taskResponseService.partsShipDate(this.task().id, this.response).subscribe(() => this.router.navigate(['main']), error => this.handleError(error));
  }

  private handleError(error: any) {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }


  private initialize(): void {
    let taskIdString: string = this.taskId();
    if (taskIdString && !isNaN(+taskIdString) && +taskIdString > 0) {
      this.iecTaskService.getTask(+taskIdString).subscribe(result => {
        this.task.set(result);
        this.entityService.getEntity("QUOTE", this.task().entityId, this.task().entityRevision).subscribe(entity => {
          this.expediteParts.set(entity.expedite);
          this.partialShipments.set(entity.partialShipmentAllowed);
        });
      }, error => this.handleError(error));
    } else {
      this.router.navigate(['main']);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['taskId'].firstChange) {
      this.initialize();
    }
  }
}
